document.addEventListener('DOMContentLoaded', function () {
  // Delay slightly so theme sections finish rendering
  setTimeout(() => {
    // Try multiple possible selectors for button/class names used earlier
    const desc = document.querySelector('.collection-hero__description') || document.querySelector('.collection-description');
    const btn = document.querySelector('.read-more-btn') || document.querySelector('.toggle-description');

    if (!desc) return;

    // Helper to parse computed values safely
    function parsePx(value, fallback = 0) {
      if (!value) return fallback;
      const n = parseFloat(value);
      return isNaN(n) ? fallback : n;
    }

    const cs = window.getComputedStyle(desc);
    // get line-height (if 'normal' or invalid, fallback to font-size * 1.25)
    let lineHeight = parsePx(cs.lineHeight, NaN);
    if (!isFinite(lineHeight) || lineHeight === 0) {
      const fontSize = parsePx(cs.fontSize, 16);
      lineHeight = fontSize * 1.25; // reasonable fallback multiplier
    }

    // include vertical padding so three visible lines aren't cut by padding
    const paddingTop = parsePx(cs.paddingTop, 0);
    const paddingBottom = parsePx(cs.paddingBottom, 0);
    const borderTop = parsePx(cs.borderTopWidth, 0);
    const borderBottom = parsePx(cs.borderBottomWidth, 0);
    const extra = paddingTop + paddingBottom + borderTop + borderBottom;

    // target height for 3 full lines
    const targetHeight = Math.ceil(lineHeight * 3 + extra + 0.5);

    // measure natural content height (full)
    const naturalHeight = desc.scrollHeight;

    // If content is taller than 3 lines -> collapse it and show button
    if (naturalHeight > targetHeight + 1) {
      // add a class so CSS/UX can depend on collapsed state
      desc.classList.add('collapsed');
      // set exact pixel max-height to show 3 full lines
      desc.style.maxHeight = targetHeight + 'px';
      desc.style.overflow = 'hidden';
      // show button (if exists)
      if (btn) {
        btn.style.display = 'inline-block';
        btn.setAttribute('aria-expanded', 'false');

        // click handler
        btn.addEventListener('click', function () {
          const isExpanded = desc.classList.toggle('expanded');
          if (isExpanded) {
            // expand to full height
            desc.style.maxHeight = '';
            desc.classList.remove('collapsed');
            btn.textContent = 'Read Less';
            btn.setAttribute('aria-expanded', 'true');
          } else {
            // collapse back to exact three-line height
            desc.style.maxHeight = targetHeight + 'px';
            desc.classList.add('collapsed');
            btn.textContent = 'Read More';
            btn.setAttribute('aria-expanded', 'false');
            // keep the collapsed section in view for UX
            desc.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      }
    } else {
      // content is short enough — ensure button hidden and no inline max-height
      if (btn) btn.style.display = 'none';
      desc.style.maxHeight = '';
      desc.classList.remove('collapsed');
    }
  }, 120); // small delay
});

// Robust Read More (waits for fonts, measures exact single-line height, handles resize)
(function () {
  function px(v){ return v ? parseFloat(String(v).replace('px','')) || 0 : 0; }
  function debounce(fn, wait){ let t; return (...a)=>{ clearTimeout(t); t = setTimeout(()=>fn(...a), wait); }; }

  async function initReadMore() {
    // wait for fonts to be ready (if supported), fallback to small delay
    if (document.fonts && document.fonts.ready) {
      try { await document.fonts.ready; } catch(e) { /* ignore */ }
    } else {
      await new Promise(r => setTimeout(r, 200));
    }

    const desc = document.querySelector('.collection-hero__description') || document.querySelector('.collection-description');
    const btn = document.querySelector('.read-more-btn') || document.querySelector('.toggle-description');
    if (!desc) return;

    // ensure paragraph margins can't interfere (CSS fallback)
    // (Don't remove if you already set in CSS)
    desc.querySelectorAll && desc.querySelectorAll('p').forEach(p => { p.style.margin = '0'; p.style.padding = '0'; });

    function measureAndApply() {
      // cleanup previous inline styles so measurement is accurate
      desc.style.maxHeight = '';
      desc.classList.remove('collapsed','expanded');

      const cs = window.getComputedStyle(desc);
      const paddingTop = px(cs.paddingTop), paddingBottom = px(cs.paddingBottom);
      const borderTop = px(cs.borderTopWidth), borderBottom = px(cs.borderBottomWidth);
      const extras = paddingTop + paddingBottom + borderTop + borderBottom;

      // create a clone to measure a single line height reliably
      const clone = desc.cloneNode(true);
      clone.style.position = 'absolute';
      clone.style.visibility = 'hidden';
      clone.style.whiteSpace = 'nowrap';
      clone.style.width = desc.clientWidth + 'px';
      clone.style.padding = '0';
      clone.style.margin = '0';
      clone.style.boxSizing = 'border-box';
      // use textContent to avoid block children changing height
      clone.textContent = (desc.textContent || '').trim().slice(0, 200) || 'A';
      document.body.appendChild(clone);
      const singleLine = Math.max(clone.getBoundingClientRect().height, px(cs.lineHeight) || px(cs.fontSize) * 1.25);
      document.body.removeChild(clone);

      // compute exact target height for N lines (3)
      const lines = 3;
      // add 1-3px safety fudge to avoid sub-pixel clipping
      const fudge = 2;
      const targetHeight = Math.ceil(singleLine * lines + extras + fudge);

      const naturalHeight = desc.scrollHeight;

      // debug log — remove/comment out if not needed
      console.info('READMORE DEBUG', { singleLine, targetHeight, naturalHeight, computedLineHeight: cs.lineHeight });

      if (naturalHeight > targetHeight + 1) {
        // collapse to exact pixel height so 3 lines display fully
        desc.classList.add('collapsed');
        desc.style.maxHeight = targetHeight + 'px';
        desc.style.overflow = 'hidden';
        if (btn) {
          btn.style.display = 'inline-block';
          btn.setAttribute('aria-expanded','false');
          btn.textContent = 'Read More';
          // remove previous listener clones
          btn.replaceWith(btn.cloneNode(true));
          const newBtn = document.querySelector('.read-more-btn') || document.querySelector('.toggle-description');
          newBtn.addEventListener('click', function () {
  const isExpanded = desc.classList.contains('expanded');

  if (!isExpanded) {
    // Expand
    const fullHeight = desc.scrollHeight;
    desc.style.maxHeight = fullHeight + 'px';
    newBtn.textContent = 'Read Less';
    newBtn.setAttribute('aria-expanded', 'true');
    desc.classList.add('expanded');
    desc.classList.remove('collapsed');

    // After transition, remove max-height so content reflows naturally
    setTimeout(() => { desc.style.maxHeight = 'none'; }, 300);
  } else {
    // Collapse back
    const targetHeight = parseFloat(newBtn.getAttribute('data-target-height'));
    desc.style.maxHeight = targetHeight + 'px';
    newBtn.textContent = 'Read More';
    newBtn.setAttribute('aria-expanded', 'false');
    desc.classList.remove('expanded');
    desc.classList.add('collapsed');
    desc.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
});

        }
      } else {
        // short content — show everything and hide button
        if (btn) btn.style.display = 'none';
        desc.style.maxHeight = 'none';
        desc.classList.remove('collapsed');
      }
    }

    // initial run
    measureAndApply();

    // re-run on resize with debounce
    window.addEventListener('resize', debounce(measureAndApply, 180));
  }

  // start
  document.addEventListener('DOMContentLoaded', initReadMore);
})();
